import { useFormik } from "formik";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTextArea from "../../../../components/common/CustomTextArea/CustomTextArea";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { addCompanyMasterAsync } from "../../../../redux/features/company-master/addCompanyMasterSlice";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import RouteNames from "../../../../AppRoutes/RouteName";

const validationSchema = Yup.object().shape({
   companyname: Yup.string()
      .required("Company Name is required")
      .min(3, "Too Short!")
      .max(50, "Too Long!"),

   companypan: Yup.string()
      .required("Company Pan is required")
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invaid pan card no!"),

   address: Yup.string()
      .required("Address is required")
      .min(10, "Address must be at least 10 characters long"),
});

export default function CompanyMasterAdd() {
   const dispatch = useDispatch();
   const navigate = useNavigate();

   const initialValues = {
      companyname: "",
      companypan: "",
      address: "",
   };

   const handleCompany = async (formData) => {
      if (!formData.companygst?.trim()) {
         delete formData.companygst;
      }
      dispatch(backdropLoadingAction(true));

      dispatch(
         addCompanyMasterAsync({
            data: formData,
            done: () => {
               formik.resetForm();
               dispatch(backdropLoadingAction(false));
               toast.success("Customer added successfully.");
               navigate(RouteNames.CompanyMasterView);
            },
            err: () => {
               dispatch(backdropLoadingAction(false));
               //toast.error("Failed to add Customer.");
            },
         }),
      );
   };

   const formik = useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: handleCompany,
   });

   const { getFieldProps, handleSubmit, touched, errors } = formik;

   return (
      <div>
         <BodyHeader title="Company Master" />

         <div className="p-3 shadow-lg">
            <div className="row">
               <div className="col-lg-12">
                  <div className="card card-primary">
                     <div className="card-header">
                        <h3 className="card-title">Company Master Details</h3>
                     </div>
                     <div className="card-body">
                        <div className="row">
                           <div className="col-12 col-sm-12 col-md-4">
                              <CustomInput
                                 require
                                 label="Company Name"
                                 id="companyName"
                                 placeholder="Enter Company Name"
                                 {...getFieldProps("companyname")}
                                 errors={touched.companyname && errors.companyname}
                                 message={errors.companyname}
                              />
                           </div>

                           <div className="col-12 col-sm-12 col-md-4">
                              <CustomInput
                                 require
                                 label="Company PAN Number"
                                 id="companyPan"
                                 placeholder="Enter Company PAN Number"
                                 {...getFieldProps("companypan")}
                                 errors={touched.companypan && errors.companypan}
                                 message={errors.companypan}
                              />
                           </div>

                           <div className="col-12 col-sm-12 col-md-4">
                              <CustomInput
                                 label="Company GST "
                                 id="companyGst"
                                 placeholder="Enter Company GST"
                                 {...getFieldProps("companygst")}
                              />
                           </div>

                           <div className="col-12 col-sm-12 col-md-12">
                              <CustomTextArea
                                 required
                                 label="Address"
                                 id="address"
                                 placeholder="Enter Address"
                                 {...getFieldProps("address")}
                                 errors={touched.address && errors.address}
                                 message={errors.address}
                              />
                           </div>

                           <div className="col-lg-12 mt-3 text-center">
                              <button
                                 className="btn btn-primary px-4 py-3"
                                 type="submit"
                                 onClick={handleSubmit}
                              >
                                 <h6 className="mb-0 text-uppercase">Submit</h6>
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
